import ProfileModal from './profile-modal';

export default {
  ProfileModal,
};
